import React from "react";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import FieldBoxComponent from "../Components/FieldBox";
import TableStepper from "../Components/TableStepper";
import { useNavigate } from "react-router-dom";

const product = [
  {
    id: 1,
    category: "Fixture",
    name: (
      <div>
        원데이 임플란트 Fixture 3.8
        <br />
        Fixture 3.8 Fixture 3.8
      </div>
    ),
    ref: "S30085C",
    receivedQty: 1,
    steps: 1,
  },
  {
    id: 2,
    category: "Fixture",
    name: (
      <div>
        원데이 임플란트 Fixture 3.8
        <br />
        Fixture 3.8 Fixture 3.8
      </div>
    ),
    ref: "S30085C",
    receivedQty: 1,
    steps: 3,
  },
  {
    id: 3,
    category: "Fixture",
    name: (
      <div>
        원데이 임플란트 Fixture 3.8
        <br />
        Fixture 3.8 Fixture 3.8
      </div>
    ),
    ref: "S30085C",
    receivedQty: 1,
    steps: 4,
  },
  {
    id: 4,
    category: "Fixture",
    name: (
      <div>
        원데이 임플란트 Fixture 3.8
        <br />
        Fixture 3.8 Fixture 3.8
      </div>
    ),
    ref: "S30085C",
    receivedQty: 1,
    steps: 5,
  },
];

const image = [
  "UCLA CCM Abutment 1.png",
  "UCLA CCM Abutment 1.png",
  "임플란트 샘플 가이드북 UCLA CCM Abutment 상품소개_ UCLA CCM Abutment 상품소개입니니니다다다.jpeg",
  "임플란트 샘플 가이드북 UCLA CCM Abutment 상품소개_ UCLA CCM Abutment 상품소개입니니니다다다.jpeg",
];

const dataQr = [
  {
    id: 1,
    lot: "F22060802",
    qrNumber: (
      <div>
        0108800752001671122
        <br />
        060817270607
      </div>
    ),
    productionDate: "2022-06-08",
    validDate: "2022-06-07",
    inventoryQty: 100,
  },
  {
    id: 2,
    lot: "F22060802",
    qrNumber: (
      <div>
        0108800752001671122
        <br />
        060817270607
      </div>
    ),
    productionDate: "2022-06-08",
    validDate: "2022-06-07",
    inventoryQty: 50,
  },
  {
    id: 3,
    lot: "F22060802",
    qrNumber: (
      <div>
        0108800752001671122
        <br />
        060817270607
      </div>
    ),
    productionDate: "2022-06-08",
    validDate: "2022-06-07",
    inventoryQty: 0,
  },
  {
    id: 4,
    lot: "F22060802",
    qrNumber: (
      <div>
        0108800752001671122
        <br />
        060817270607
      </div>
    ),
    productionDate: "2022-06-08",
    validDate: "2022-06-07",
    inventoryQty: 0,
  },
];

const DetailDefectReception = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-[55rem]">
      <div className="border-b border-b-1">
        <TitlePage title="불량접수 관리 > 불량접수 내역 상세정보" />
      </div>
      <FieldBoxComponent />
      <div className="mt-10">
        <p className="font-bold text-sm">상품정보</p>
        <p className="my-2">
          총 <span className="font-bold">{product.length}</span>건
        </p>
      </div>
      <TableStepper image={image} dataQr={dataQr} filteredItems={product} />
      <div className="flex justify-end mt-6">
        <button
          onClick={() => navigate(`/defect-reception`)}
          className="border w-28 py-2 rounded-[4px] border-title-black text-title-black"
        >
          목록
        </button>
      </div>
    </div>
  );
};

export default DetailDefectReception;
